(() => {
  const main = document.querySelector('main[data-template]');
  if (!main) return;

  if (main.dataset.template === 'index') {
    const body = main.querySelector('.bmg-hero__copy .bmg-copy p');
    if (body) {
      body.textContent = 'BREATHmg is a structured 60-day, 40 Hz binaural beats breathwork program built for beginners and people who struggle to settle their attention.';
    }

    const track = document.getElementById('bmgHeroTrack');
    const signal = main.querySelector('.bmg-hero-signal');

    // Playback itself (the initial play() attempt on load, and the retry on
    // the user's first interaction) is owned by bmg-hero-signal.js, which
    // drives the track off the same timeline as the flower-to-orb animation.
    // This file used to also call track.play() and reset track.currentTime
    // independently on every load, which raced the other script's own
    // attempt on the same <audio> element and is what was breaking playback.
    // This file now only renders the mute/unmute control and keeps its label
    // truthful to the track's real state.
    if (track && signal && !signal.querySelector('.bmg-hero-audio-toggle')) {
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'bmg-hero-audio-toggle';

      const syncToggle = () => {
        toggle.textContent = track.muted ? 'Sound' : 'Mute';
        toggle.setAttribute('aria-pressed', track.muted ? 'true' : 'false');
        toggle.setAttribute('aria-label', track.muted ? 'Turn on homepage animation audio' : 'Mute homepage animation audio');
      };

      toggle.addEventListener('click', () => {
        track.muted = !track.muted;
        if (!track.muted && track.paused) {
          const attempt = track.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        }
        syncToggle();
      });

      track.addEventListener('volumechange', syncToggle);
      syncToggle();
      signal.appendChild(toggle);
    }
  }

  if (main.dataset.template === 'page.bmg-program') {
    const body = main.querySelector('.bmg-page-hero__body .bmg-copy');
    if (body) {
      body.innerHTML = '<p>Seventeen guided recordings move you through three progressive phases over 60 days. My BREATHmg keeps your next practice, progress, and private notes together, with every recording and guide yours to keep.</p><p>One seat is $39. Four Breath Buddies seats are $99. No subscription.</p>';
    }
  }
})();